import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './form-block.module.scss';
import IconBox11 from './components/Icone-box11/Icone-box11';
import { FormBlockType } from '@/types/contactsBlock.types';
import ContactFormServices from './components/ContactFormServices/ContactFormServices';
import ContactForm from './components/ContactForm/ContactForm';

const ContactsBlock: NextPage<FormBlockType> = ({
  className = '',
  device = 'Desktop',
  title,
  text,
  formType,
}) => {
  return (
    <section
      className={[styles.formblock, className].join(' ')}
      data-device={device}
    >
      <div className="container">
        <div className={styles.container}>
          <section className={styles.leftcol}>
            <div className={styles.text}>
              <h2 className={styles.title}>{title}</h2>
              <div className={styles.descriptor}>{text}</div>
            </div>
            <div className={styles.cta}>
              <h3
                className={`${formType === 'services' ? styles.titleServices : styles.title1} `}
              >
                Contact Info
              </h3>
              <div className={styles.contacts}>
                <a
                  href="tel:18333593372"
                  className={styles.phoneLink}
                  target="_blank"
                >
                  <IconBox11
                    title="Phone Number"
                    info="1-833-FLY-HERA"
                    iconSrc="/img/contactsBlock/phone.svg"
                  />
                </a>
                <div className={styles.iconBox2}>
                  <Image
                    className={styles.icon}
                    loading="lazy"
                    width={64}
                    height={64}
                    sizes="100vw"
                    alt=""
                    src="/img/contactsBlock/addres.svg"
                  />
                  <div className={styles.title3}>
                    <div className={styles.title2}>Physical Address</div>
                    <div className={styles.info}>
                      <p className={styles.fairchildDr}>15965 Fairchild Dr</p>
                      <p className={styles.clearwaterFl33762}>
                        Clearwater, FL 33762
                      </p>
                    </div>
                  </div>
                </div>
                <a
                  href="mailto:charter@heraflight.com"
                  className={styles.emailLink}
                >
                  <IconBox11
                    title="Charter Quotes"
                    info="charter@heraflight.com"
                    iconSrc="/img/contactsBlock/mail.svg"
                  />
                </a>
              </div>
            </div>
          </section>
          <section className={styles.rightcol}>
            {formType === 'services' ? (
              <ContactFormServices />
            ) : (
              <ContactForm />
            )}
          </section>
        </div>
      </div>
    </section>
  );
};

export default ContactsBlock;
